
import { ReactSVG } from "react-svg";
import Div100vh from "react-div-100vh";
import isNull from "lodash/isNull";
import leftCloudMobile from "../../../../../assets/images/unsupported-language/mobile-left-cloud.svg";
import nextArrow from "../../../../../assets/images/unsupported-language/locale-error-arrow.svg";
import { ConditionalRender, InteractivePortalLogo } from "../../../../common";

const MobileUnsupportedLocale = ({ language, handleContinueInEnglish }) => {
    return (
        <Div100vh
            className="flex overflow-hidden"
        >
            <div className="h-full w-full relative navy-blue-scrollbar">
                <ReactSVG src={leftCloudMobile} className='absolute text-[#AFC6DF] opacity-50 bottom-0 left-0 z-[-1] xs:hidden block' />
                <div className="h-full w-full pt-[66px] pb-[38px] flex flex-col">
                    <InteractivePortalLogo
                        className="flex justify-center -ml-12"
                    />
                    <div className="h-full w-full flex justify-center items-center">
                        <div className="flex flex-col gap-8 2xl:gap-10 items-center">
                            <div className="text-center text-standart-ocean font-bold text-[40px] leading-[40px]">
                                Unsupported language
                            </div>
                            <div className="text-center text-[#4598B1] font-bold text-[18px] leading-[18px] tracking-[0.2px] max-w-[90%]">
                                {isNull(language) ? "Unfortunately we don't speak that yet" : `Unfortunately we don't speak ${language} yet`}
                            </div>
                            <ConditionalRender condition={!isNull(language)}>
                                <div className="text-center text-[#95AFCB] font-normal text-[16px] leading-[20px] 2xl:text-[18px] 2xl:leading-[25px] tracking-[0.16px]">
                                    We're working on it.
                                </div>
                            </ConditionalRender>
                            {/* Hiding this temporarily */}
                            {/* <button onClick={handleContinueInEnglish} className='h-[40px] w-[316.5px] flex justify-center items-center gap-3 bg-light-purple text-white rounded-[25px]'>
                                <ReactSVG src={nextArrow} />
                                <span className="font-medium text-[13px] leading-normal tracking-[3.9px] uppercase">
                                    CONTINUE IN ENGLISH
                                </span>
                            </button> */}
                        </div>
                    </div>
                </div>
            </div>
        </Div100vh>
    )
}

export default MobileUnsupportedLocale;